export default __webpack_public_path__ + "static/media/02-alt.34685738.png";